
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-dnacanvas",
      function () {
        return require("private-next-pages/why-dnacanvas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-dnacanvas"])
      });
    }
  